import React from 'react'
import { LoaderIcon } from 'lucide-react'
import { Box, CircularProgress } from '@mui/material'

export const Loader: React.FC = () => {
  return (
    <Box
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      width={'100%'}
      position={'absolute'}
      sx={{
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }}
      zIndex={50}
    >
      <CircularProgress />
    </Box>
  )
}
